import { AlertTriangle, X } from "lucide-react";

export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancelar",
  onConfirm,
  onClose,
  tone = "danger",
  busy = false,
}) {
  return (
    <div
      className="suite-modal-backdrop"
      role="presentation"
      onMouseDown={onClose}
    >
      <div
        className="suite-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="suite-confirm-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          className="suite-icon-button suite-dialog-close"
          onClick={onClose}
          aria-label="Cerrar"
        >
          <X size={19} />
        </button>
        <span className={`suite-dialog-icon suite-dialog-icon--${tone}`}>
          <AlertTriangle size={22} />
        </span>
        <h2 id="suite-confirm-title">{title}</h2>
        <p>{description}</p>
        <div className="suite-dialog-actions">
          <button
            className="suite-button suite-button--secondary"
            onClick={onClose}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            className={`suite-button suite-button--${tone}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
